module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABUSURBVEiJYzT33mfMQEPAREvDRy0gCrBgE/zPwDiTHMMYGf6nE2UBxBIGklIXIwPDWWziQz8ORi0YtWDUgoEq7BgYcJctVLEAW6lILhj6cTD0LQAAyN0I4H750ZgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/month-light.png
// module id = F4UT
// module chunks = 0